import React, { Component } from 'react';
import Filter from './Filter';
import List from './List';
import Fetch from '../../../../../common/Fetch';
import API_URL from '../../../../../common/url';
import dictCache from '../../../../../common/dictCache';

class TablePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            load: null,
            contractTypeList: [],
            belongingToUnitList:[],
            businessList: [],
        };
    }
    
    search = () => {
        this.setState({ load: {} });
    }

    loadTypeConfigureList = () => {
        this.setState({ loading: true });
        dictCache.getDict('TYPE_CONFIGURE', cb => {
            Fetch.post(API_URL.common.typeConfigureList, {
                // offset: current,
                // limit: pageSize,
            }).then(cb).catch(err => {
                console.error(err);
                this.setState({ loading: false });
            });
        }, res => {
            const { contractTypeList, } = res;
            this.setState({
                //pagination,
                contractTypeList,
                loading: false,
            });
        });
    }

    queryBelongingToUnit = () => {
        this.setState({ loading: true });
        dictCache.getDict('UNIT_BELONGING', cb => {
            Fetch.post(API_URL.contract.queryUnitOfBelongingList, {
                offset: 1,
                limit: 999,
            }).then(cb).catch(err => {
                console.error(err);
                this.setState({ loading: false });
            });
        }, res => {
            const { datas, } = res;
            this.setState({
                belongingToUnitList:datas,
                loading: false,
            });
        });
    }

    queryWithLevelByParams = () => {
        this.setState({ loading: true });
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            Fetch.post(API_URL.common.queryWithLevelByParams, {
                typeName: 'LINE_OF_BUSINESS'
            }).then(cb).catch(err => {
                console.error(err);
                this.setState({ loading: false });
            });
        }, res => {
            this.setState({ loading: false, businessList: res.typeConfigureList || [] });
        });
    }

    componentDidMount() {
        this.loadTypeConfigureList();
        this.queryBelongingToUnit();
        this.queryWithLevelByParams();
    }

    render() {
        const { searchParams, clientHeight, onChange } = this.props;
        const { load,contractTypeList,belongingToUnitList,businessList } = this.state;
        const height = clientHeight - 72 - 94 - 45 - 60;

        return (
            <div className="pane-item-content">
                <Filter
                    search={this.search}
                    searchParams={searchParams}
                    belongingToUnitList={belongingToUnitList}
                    onChange={onChange}
                    contractTypeList={contractTypeList}
                    businessList={businessList}
                />
                <List
                    load={load}
                    height={height}
                    searchParams={searchParams}
                />
            </div>
        );
    }
}

export default TablePage;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/ARSheet/ARSheetS/TablePage/index.js